export default (stylingPoints = { fetchuser: 0, fetchEnterprise: 0 }, action) => {
    switch (action.type) {
        case "FETCH_USER":
            return {...stylingPoints, fetchuser: stylingPoints.fetchuser + 1}
        case "FETCH_ENTERPRISE":
            return {...stylingPoints, fetchEnterprise: stylingPoints.fetchEnterprise + 1}
        default:
            return stylingPoints;
    }
}